import Vue from 'vue';
import VueCompositionAPI, { provide } from '@vue/composition-api';
// import VueApollo from 'vue-apollo';
import VueRouter from 'vue-router';
import { createPinia, PiniaVuePlugin } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { ApolloClients } from '@vue/apollo-composable';

import App from './App.vue';

import router from './router';
import vuetify from './plugins/vuetify';

import { gatewayClient, alphaClient, speedboatClient } from './apollo.config';

Vue.use(VueCompositionAPI);

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

Vue.use(VueRouter);

new Vue({
  setup () {
    provide(ApolloClients, {
      default: gatewayClient,
      alphaClient: alphaClient,
      speedboatClient: speedboatClient
    });
  },
  router,
  vuetify,
  pinia,
  render: h => h(App)
}).$mount('#app');
